import { useDispatch } from 'react-redux';
import { clearRmaInvoices } from '@client/myAccount/rma/redux/rma/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useClearRmaInvoicesAction = (): typeof clearRmaInvoices => {
  const dispatch = useDispatch();

  return bindActionCreators(clearRmaInvoices, dispatch);
};
